// config.js
const config = {
    // apiUrl: 'http://localhost:3001',
    apiUrl: 'https://battak-kargo.kz:3001',
    
    nameCargo: 'BATTAK KARGO',
    vapidPublicKey: 'BJtBjK8np_BeUhsJubD6JLvmmGSDGPWlbOC_wqrY6Y7Qnsv4NorYvAAdV3-so5slfk1aru_j9MehVv3ggqmAm90'
  };
  
  
export default config;
